import type { AxiosInstance } from 'axios'

import { createAxiosClient } from './axios.ts'

export interface JsonHttpConfig {
  responseType?: 'json'
}

export interface BlobHttpConfig {
  responseType: 'blob'
}

export type HttpConfig = JsonHttpConfig | BlobHttpConfig

export interface Http {
  get: ((url: string, config: BlobHttpConfig) => Promise<Blob>) &
    (<T>(url: string, config?: JsonHttpConfig) => Promise<T>)
  post: ((url: string, data: unknown, config: BlobHttpConfig) => Promise<Blob>) &
    (<T>(url: string, data?: unknown, config?: JsonHttpConfig) => Promise<T>)
  put: ((url: string, data: unknown, config: BlobHttpConfig) => Promise<Blob>) &
    (<T>(url: string, data?: unknown, config?: JsonHttpConfig) => Promise<T>)
  delete: ((url: string, config: BlobHttpConfig) => Promise<Blob>) &
    (<T>(url: string, config?: JsonHttpConfig) => Promise<T>)
}

class HttpClient implements Http {
  constructor(private readonly axios: AxiosInstance) {}

  get(url: string, config: BlobHttpConfig): Promise<Blob>
  get<T>(url: string, config?: JsonHttpConfig): Promise<T>
  async get<T>(url: string, config?: HttpConfig): Promise<T> {
    const response = await this.axios.get<T>(url, config)
    return response.data
  }

  post(url: string, data: unknown, config: BlobHttpConfig): Promise<Blob>
  post<T>(url: string, data?: unknown, config?: JsonHttpConfig): Promise<T>
  async post<T>(url: string, data?: unknown, config?: HttpConfig): Promise<T> {
    const response = await this.axios.post<T>(url, data, config)
    return response.data
  }

  put(url: string, data: unknown, config: BlobHttpConfig): Promise<Blob>
  put<T>(url: string, data?: unknown, config?: JsonHttpConfig): Promise<T>
  async put<T>(url: string, data?: unknown, config?: HttpConfig): Promise<T> {
    const response = await this.axios.put<T>(url, data, config)
    return response.data
  }

  delete(url: string, config: BlobHttpConfig): Promise<Blob>
  delete<T>(url: string, config?: JsonHttpConfig): Promise<T>
  async delete<T>(url: string, config?: HttpConfig): Promise<T> {
    const response = await this.axios.delete<T>(url, config)
    return response.data
  }
}

export const http: Http = new HttpClient(createAxiosClient())
